var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlloyWheels24 = function SvgAlloyWheels24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.709a2.537 2.537 0 0 1-.703 1.42 1.85 1.85 0 0 1-1.306.553c-.477-.003-.937-.205-1.301-.57a2.548 2.548 0 0 1-.69-1.43m8.672 5.824a2.537 2.537 0 0 1-1.582.078 1.847 1.847 0 0 1-1.12-.871c-.23-.418-.277-.918-.136-1.414.143-.496.465-.956.913-1.299M5.023 11.506a2.537 2.537 0 0 0 1.583.078c.494-.145.89-.453 1.12-.871.229-.418.277-.918.135-1.414A2.548 2.548 0 0 0 6.949 8m7.268 10.02a2.537 2.537 0 0 1-.322-1.551c.067-.51.31-.95.687-1.241.377-.292.864-.417 1.376-.353a2.548 2.548 0 0 1 1.424.7m-7.217 2.445a2.536 2.536 0 0 0 .322-1.551c-.066-.51-.31-.95-.687-1.241-.377-.292-.864-.417-1.376-.353a2.548 2.548 0 0 0-1.424.7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgAlloyWheels24;